// extracted by mini-css-extract-plugin
export default {"fill":"SearchDropdown_fill__oXRdL","popover":"SearchDropdown_popover__aUpVH","queryColor":"SearchDropdown_queryColor__hkSDO"};